import NoRecord from "screens/sharedScreens/noRecord/NoRecord";
import CustomTableGrid from "components/uiComponents/CustomTableGrid";
import FormikControl from "components/wrapperComponents/FormikControl";
import { msgTypes } from "constants/msgTypes";
import { Form, Formik } from "formik";
import { MembershipModel } from "model/screensModels/membership/MembershipModel";
import { MailRequestModel } from "model/utilModels/MailRequestModel";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { ResponseModel } from "model/utilModels/ResponseModel";
import React, { useEffect, useMemo, useRef, useState } from "react";
import MailRequestForm from "screens/menu/mailRequestForm/MailRequestForm";
import { LocalStorageService } from "services/auth/LocalStorageService";
import { MemberSearchService } from "services/menu/memberSearchService/MemberSearchService";
import { UtilService } from "services/shared/UtilService";
import "./MemberSearch.scss";
import { RequestModel } from "model/utilModels/RequestModel";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button } from "@material-ui/core";
import { RouteType } from "constants/RouteType";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Tooltip from '@mui/material/Tooltip';
import { CompanyServicesModel } from "model/screensModels/CompanyServicesModel";
import { CompanyServicesService } from "services/menu/companyServicesService/CompanyServicesService";

const MemberSearch = ({ fromDashboard = false }) => {
  const [initialValue, setInitialValue] = useState(new MembershipModel());
  const [viewMode, setViewMode] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [memberList, setMemberList] = useState(new ResponseModel());
  const [companyServiceList, setCompanyServiceList] = useState<CompanyServicesModel[]>([])
  const [noRecord, setNoRecord] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [mailRequestModel, setMailRequestModel] = useState(
    new MailRequestModel()
  );
  const [exportAsExcel, setExportAsExcel] = useState({})
  const formikRef = useRef(null);
  const [flag, setFlag] = useState(true);
  const [companyList, setCompanyList] = useState([]);
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [searchFlag, setSearchFlag] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: "",
    pageNumber: "",
    filter: "",
    orderBy: "",
    desc: "",
  });
  const [showMessageSection, setShowMessageSection] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    loadCountry();
    loadCompany();
    getLoginMemberDetails();
    //setSearchFlag(true);
    getParamData();
    getCompanyServiceList();
  }, []);

  const getParamData = async () => {
    try {
      const companyId = location.state?.selectedCompanyId
      if (companyId != undefined) {
        const membershipModel = new MembershipModel();
        membershipModel.companyId = location.state?.selectedCompanyId;
        formikRef.current.setFieldValue('companyId', companyId)
        getSearchCompanyList(membershipModel);
      }
    } catch (error) {
    }
  }

  const getCompanyServiceList = async () => {
    const res = await CompanyServicesService.getAllCompanyServicesList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setCompanyServiceList(res.data)
      }
    }

  }

  useEffect(() => {
    if (flag === false) {
      setInitialValue(new MembershipModel())
      formikRef.current.setFieldValue('companyId', '')
      formikRef.current.setFieldValue('serviceId', '')
      formikRef.current.setFieldValue('country', '')
      getLoginMemberDetails();
    }
  }, [flag]);

  useEffect(() => {
    getSearchCompanyList(formikRef.current.values);
  }, [pagination.pageNumber, pagination.pageSize, pagination.filter, pagination.orderBy, pagination.desc])

  useEffect(() => {
    if (selectedCompany.length === 0) {
      setShowMessageSection(false);
    }
    mailRequestModel.to = selectedCompany.map((data) => { return data.companyEmail })
    mailRequestModel.toCompanyId = selectedCompany.map((data) => { return data.companyId })
  }, [selectedCompany])



  //load country
  const loadCountry = async () => {
    const res = await UtilService.getCountryList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setCountryList(res.data);
    }
  };

  // Load Company
  const loadCompany = async () => {
    const res = await UtilService.getCompanyList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setCompanyList(res.data);
      } else {
        setCompanyList([]);
      }
    }
  };


  const getLoginMemberDetails = async () => {
    const companyDetails = JSON.parse(await LocalStorageService.getUserDetails());
    const mailObject = new MailRequestModel();
    
    mailObject.from = companyDetails.companyEmail;
    mailObject.to = [];
    
    // Move contactPerson emails to cc
    mailObject.cc = companyDetails.contactPerson.map(option => option.email);
  
    // Fix "cs@oneworldnetwork.co" in bcc
    mailObject.bcc = "cs@oneworldnetwork.co";
  
    mailObject.subject = "";
    mailObject.body = "";
    mailObject.fromCompanyId = companyDetails.companyId;
  
    setMailRequestModel(mailObject);
  };
  

  //Prepare Data for API
  const prepareRequestBody = async (values: MembershipModel) => {
    const prepareData = new RequestModel();
    prepareData.pageNumber = 0; // Set pageNumber to 0
    prepareData.pageSize = 0;
    prepareData.filter = pagination.filter;
    prepareData.orderBy = pagination.orderBy;
    prepareData.desc = pagination.desc;
    prepareData.companyId = values?.companyId;
    prepareData.countryId = values?.country ? Number(values.country) : 0;
    prepareData.serviceId = values?.serviceId ? values?.serviceId : "";

    return prepareData;
  };


  const getSearchCompanyList = async (values: MembershipModel) => {
    // setMemberList(new ResponseModel());
    const requestData = await prepareRequestBody(values);
    const res = await MemberSearchService.memberSearch(requestData);
    let filterData = undefined;
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setMemberList(res);
        setFlag(true);
        const userType = await LocalStorageService.getUserRole();
        if(userType===msgTypes.USER_TYPE.ADMIN){
            filterData = res.data.tbody.map((data: MembershipModel) => {
              return {
                "Company Name": data.companyName,
                "Type": (data.isHeadOffice || data.isHeadOffice===null) ? "Head Office" : "Branch Office",
                "Email": data.companyEmail,
                "Phone Number": data.primaryPhoneNumber,
                "Membership Type": data.membershipType,
                "Country": data.countryName,
                "City": data.stateName,
                "Address 1": data.addressLine1,
              }
            })
        }
        setExportAsExcel({ fileName: "MemberSearchList.xlsx", data: filterData })
      } else {
        setMemberList(new ResponseModel());
        setExportAsExcel({ fileName: "MemberSearchList.xlsx", data: [] })
      }
    }
  };


  const displayMessageSection = () => {
    setShowMessageSection(true);
  }

  const viewProfile = async (companyId: string) => {
    //if user click on view profile then data will be saved 
    const res = await UtilService.saveVisitorDetails(companyId);
    navigate(RouteType.HOME + RouteType.COMPANY_PROFILE, {
      state: { companyId },
    });
  }

  const columns = useMemo(() =>
    [
      {
        header: 'Company Name',
        Cell: ({ renderedCellValue, row }) => (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div onClick={(e) => { viewProfile(row.original.companyId) }} className="decoration-none">
              {row.original.companyName}
            </div>
          </Box>
        ),
        size: 150
      },
      {
        accessorKey: "countryName",
        header: "Country"

      },
      {
        header: 'Type',
        Cell: ({ renderedCellValue, row }) => (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {row.original.isHeadOffice ? "Head Office" : "Branch Office"}
          </Box>
        ),
        size: 100
      },
      {
        accessorKey: "companyEmail",
        header: "Email",
        size: 150
      },
   
      {
        header: "Phone Number",
        accessorKey: "primaryPhoneNumber",

        size: 200
      },
      {
        header: 'Visit Profile',
        Cell: ({ renderedCellValue, row }) => (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <a href="javascript:void(0)" onClick={(e) => { viewProfile(row.original.companyId) }}>
              {/* <RemoveRedEyeIcon /> */}
              <Tooltip title="View Profile">
                <RemoveRedEyeIcon fontSize="small" />
              </Tooltip>
            </a>
          </Box>
        ),
        size: 50
      },
    ], []);



  return (
    <>
      <div className="container container-h-full">
        <div className="content-subheader">
          {!fromDashboard && <h2 className="font-weight-bolder mr-3">Member Search</h2>}
        </div>
        <div className="h-100">
          <Formik
            enableReinitialize={true}
            initialValues={initialValue}
        
            onSubmit={values => {
            }}
            innerRef={formikRef}
          >
            {({values}) => (
              <Form>
                <div className=" sub-content-sec recently-blog card--">
                  <div className="row">
                    <div className="col-xl-4 col-md-6 col-md-4">
                      <FormikControl
                        control="autocomplete"
                        name="companyId"
                        label="Company Name"
                        options={companyList}
                        keyfield="companyName"
                        valuefield="companyId"
                        disabled={viewMode}
                      />
                    </div>
                    <div className="col-xl-3 col-md-6 col-md-4">
                      <FormikControl
                        control="autocomplete"
                        name="serviceId"
                        label="Category"
                        placeholder="Select Category"
                        options={companyServiceList}
                        keyfield="serviceName"
                        valuefield="serviceId"
                      />
                    </div>
                    <div className="col-xl-3 col-md-6 col-md-4">
                      <FormikControl
                        control="autocomplete"
                        name="country"
                        label="Country"
                        placeholder="Any Country"
                        // requiredField
                        options={countryList}
                        keyfield="name"
                        valuefield="countryIdentifier"
                      />
                    </div>
                    <div className="col-xl-2 col-md-6 d-flex align-items-center">
                   
                      <Button
                        type="button"
                        variant="contained"
                        className="btn btn-submit mt-2"
                        color="primary"
                        onClick={()=>getSearchCompanyList(values)}
                      >
                        Search
                      </Button>
                    </div>
                  </div>
                </div>
                </Form>
            )}
          </Formik>
                {/* <hr></hr> */}
                <>
                  {memberList.data.tbody && memberList.data.tbody.length && flag ? (
                    <>
                      <div className="sub-content-sec card-- h-auto selected-member-search">
                        <CustomTableGrid
                          item={
                            <FormikControl
                              control='materialTable'
                              tableColumn={columns}
                              tableData={memberList}
                              //formikValue={formik}
                              setPagination={setPagination}
                              enableRowSelection={true}
                              enableRowNumbers={false}
                              setSelectedRows={setSelectedCompany}
                              exportExcel={exportAsExcel}
                              
                            />
                          }
                        />
                      </div>
                      {selectedCompany.length && !showMessageSection ? (
                        <div>
                          <FormikControl
                            control="button"
                            color="primary"
                            className='btn btn-submit mt-0'
                            label="Send Quotes"
                            onClick={displayMessageSection}
                          />
                        </div>
                      ) : ""}
                    </>
                  ) : (
                    noRecord && <NoRecord />
                  )}
                </>
              
        </div>

        {(selectedCompany.length > 0 && flag && showMessageSection) ? (
          <div className="sub-content-sec card-- mt-0">
            <MailRequestForm setFlag={setFlag} mailrequestModel={mailRequestModel} />
          </div>
        ) : (
          ""
        )}

      </div>
    </>
  );
};

export default MemberSearch;
